import { AddActionCombinedProps } from './types';

const usePresenter = (props: AddActionCombinedProps): AddActionCombinedProps => {
  return props;
};

export default usePresenter;
